import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import 'rxjs/add/operator/switchMap';

export class EnglishService {

    constructor() {}

    private answers: any[];
    private correct: any;
    private data: any;

    private English = [
        {
            'number': 1,
            'description': '1. If Mary ------- so annoying, she ------- a boyfriend.',
            'options': [
                { 'description': "a) weren't ...would have", 'value': 'a'},
                { 'description': "b) wasn't ... wouldn't have", 'value': 'b' },
                { 'description': "c) were ... would had gotten", 'value': 'c' },
                { 'description': "d) was ... wouldn't had gotten", 'value': 'd' }
            ],
            'answer': 'a'
        },
        {
            'number': 2,
            'description': '2. It can be inferred from the text that…',
            'options': [
                { 'description': "a) all cats purr when they are happy.", 'value': 'a' },
                { 'description': "b) purring is relaxing for cats.", 'value': 'b' },
                { 'description': "c) both happiness and pain can be shown by purring.", 'value': 'c' },
                { 'description': "d) when a cat is purring, it should not be bothered.",'value': 'd'  }
            ],
            'answer': 'b'
        },
        {
            'number': 3,
            'description': '3. Choose the option that BEST combines the following phrases. (1)Frank is a handsome guy. (2)Frank is intelligent. (3)Frank is small. (4)Frank is from France.',
            'options': [
                { 'description': "a) Frank is a small, french, intelligent and handsome guy.", 'value': 'a' },
                { 'description': "b) Frank is a handsome, small, intelligent, French guy.", 'value': 'b' },
                { 'description': "c) Frank is a handsome, intelligent, small, French guy.", 'value': 'c' },
                { 'description': "d) Handsome Frank is small and intelligent, he is also from France.", 'value': 'd' }
            ],
            'answer': 'c'
        },
        {
            'number': 4,
            'description': '4. Linda loves travelling the world whatever she can do it.',
            'options': [
                { 'description': "a) love", 'value': 'a' },
                { 'description': "b) to travel", 'value': 'b' },
                { 'description': "c) whenever", 'value': 'c' },
                { 'description': "d) NO ERROR", 'value': 'd' }

            ],
            'answer': 'c'
        },
        {
            'number': 5,
            'description': '5. Which punctuation mark should be inserted in the blank in sentence 5?',
            'options': [
                { 'description': "a) Hyphen.", 'value': 'a' },
                { 'description': "b) Colon.", 'value': 'b' },
                { 'description': "c) Semicolon.", 'value': 'c' },
                { 'description': "d) Question mark.", 'value': 'd' }
            ],
            'answer': 'c'
        }
    ]

    private explications = [
      {
        "description": "https://www.youtube.com/embed/xBz7K_sTx8U",
      },

      {
        "description": "https://www.youtube.com/embed/EI6jBAAkqkQ",
      },

      {
        "description": "https://www.youtube.com/embed/dvHWU0MA4Qg",
      },

      {
        "description": "https://www.youtube.com/embed/Hr4CaH4nTow",
      },

      {
        "description": "https://www.youtube.com/embed/ktPIuwVhJMQ",
      },
    ];

    setAnswers(aux: any[]) {
        this.answers = aux;
    }

    getExplications() {
      return this.explications;
    }

    getAnswers() {
        return this.answers;
    }

    setCorrectAnswers(corects: any) {
      // console.log("Recibe Ingles", corects);
      this.correct = corects;
    }

    getCorrectAnswers() {
      // console.log("Envio Ingles", this.correct);
        return this.correct;
    }

    getQuestion() {
        return this.English;
    }

    setData(data: any) {
      this.data = data;
    }

    getData() {
      return this.data;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/english.service.ts